import { Button, Modal } from "react-bootstrap";
import styles from "./modal.module.css";
import React from "react";

type Props = {
    show: boolean;
    onHide: () => void;
    onConfirm: () => void;
    title: string;
    message: React.ReactNode;
    confirmText: string;
    cancelText: string;
}

export const ConfirmModal = ({show, onHide, onConfirm, title, message, confirmText, cancelText}: Props) => {
    return (
        <Modal show={show} onHide={onHide} centered backdrop="static">
            <Modal.Header closeButton className={styles.background}>
                {title}
            </Modal.Header>
            <Modal.Body className={styles.background}>{message}</Modal.Body>
            <Modal.Footer className={styles.background}>
                <Button variant="secondary" onClick={onHide}>{cancelText}</Button>
                <Button variant="danger" onClick={onConfirm}>{confirmText}</Button>
            </Modal.Footer>
        </Modal>
    )
}
